import Vue from 'vue';
import Vuex from 'vuex';
import session from '@demre/client-common/src/components/jwt-refresher/session';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    usuario: {},
    modulos: {},
    proceso: {},
    anioProcesoAdmision: null,
    fspCodigo: null,
  },
  mutations: {
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
    setModulos(state, modulos) {
      state.modulos = modulos;
    },
    setAnioProcesoAdmision(state, anioProcesoAdmision) {
      state.anioProcesoAdmision = anioProcesoAdmision;
    },
    setProceso(state, proceso) {
      state.proceso = proceso;
    },
    setFspCodigo(state, fspCodigo) {
      state.fspCodigo = fspCodigo;
    },
  },
  getters: {
    getUsername(state) {
      let username = '';
      if (state.session?.token)  {
        const b64ToJsonStr = str => window.atob(str);
        const payload = state.session.token.split('.')[1];
        ({ username } = JSON.parse(b64ToJsonStr(payload)));
      }
      return username;
    }
  },
  modules: {
    session,
  }
});
